import type { Assistant } from "@soulbyte/core";
import { createContext, useContext } from "react";

const ThreadsContext = createContext(
  {} as {
    assistant: Assistant;
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    isSearching: boolean;
    setIsSearching: (isSearching: boolean) => void;
  },
);
export default ThreadsContext;

export function useThreadsContext() {
  const context = useContext(ThreadsContext);
  if (context === undefined) {
    throw new Error("useThreadsContext must be used within a ThreadsProvider");
  }
  return context;
}
